<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      xmlns="http://www.w3.org/2000/svg">
  <path
      d="M11.125 17.6538L5.4712 12L11.125 6.34619L12.1788 7.40002L7.59422 12L12.1788 16.6L11.125 17.6538ZM17.475 17.6538L11.8212 12L17.475 6.34619L18.5288 7.40002L13.9442 12L18.5288 16.6L17.475 17.6538Z"
      fill="#333333"/>
</svg>
</template>
